<script lang="ts">
    import { gettext as _, tgettext } from 'hydria/services/gettext'

    import type { ILocalRevision } from './pageDefs'

    import SimpleOrderedListing from 'hydria/components/SimpleListings/SimpleOrderedListing.svelte'

    const singular = 'nouvelle'
    const plural = 'nouvelles'
    const baseUrl = '/nouvelles'

    const pageTitle = tgettext('Nouvelles')
    const createButtonText = tgettext('Ajouter une nouvelle')
    const pageDescMd = tgettext('(page publique « _Nouvelles_ » et _modal de déconnexion_)')

    function resolveModalField(value: any, lg: string, revision: ILocalRevision) {
        if (value == true && revision.deleg == true) return $_('Si délégué')
        if (value == true) return $_('Oui')
        return $_('Non')
    }

    interface Props {
        route: any
    }

    let { route }: Props = $props()
</script>

<SimpleOrderedListing
    {route}
    {singular}
    {plural}
    {baseUrl}
    {pageTitle}
    {createButtonText}
    {pageDescMd}
    extraLgFields={[
        {
            id: 'modal_signout',
            name: tgettext('Modal/Déconnexion'),
            empty: tgettext('Non'),
            resolve: resolveModalField,
        },
    ]}
/>
